import { FC } from "react";
import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import CheckboxLabel from "../../pages/dashboard/components/checkbox-label";
import { NotificationsTypeEnum } from "service/types/enum/notifications-enum";

interface NotificationTypeSelectorProps {
  value: string[] | undefined;
  onChange: (value: string[]) => void;
  showPush?: boolean;
  showEmail?: boolean;
}

const NotificationTypeSelector: FC<NotificationTypeSelectorProps> = ({
  value = [],
  onChange,
  showPush = true,
  showEmail = true,
}) => {
  const handleNotificationTypeChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { value: checkboxValue, checked } = e.target;
    const currentTypes = value || [];

    if (checked) {
      if (!currentTypes.includes(checkboxValue)) {
        onChange([...currentTypes, checkboxValue]);
      }
    } else {
      onChange(currentTypes.filter((type) => type !== checkboxValue));
    }
  };

  return (
    <FormGroup>
      {showPush && (
        <FormControlLabel
          style={{ alignItems: "flex-start" }}
          control={
            <Checkbox
              name="notificationType"
              value={NotificationsTypeEnum.push}
              onChange={handleNotificationTypeChange}
              checked={value?.includes(NotificationsTypeEnum.push) ?? false}
            />
          }
          label={
            <CheckboxLabel
              primaryText="Push"
              subtitle="Recipients will receive a notification on their device."
            />
          }
        />
      )}
      {showEmail && (
        <FormControlLabel
          control={
            <Checkbox
              name="notificationType"
              value={NotificationsTypeEnum.email}
              onChange={handleNotificationTypeChange}
              checked={value?.includes(NotificationsTypeEnum.email) ?? false}
            />
          }
          label={
            <CheckboxLabel
              primaryText="Email"
              subtitle="Recipients will receive a notification by email."
            />
          }
        />
      )}
    </FormGroup>
  );
};

export default NotificationTypeSelector;
